/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_EmptyInputs */

const cs_chat_empty = /** @type {(inputs: Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné konverzace.`)
};

const en_chat_empty = /** @type {(inputs: Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations yet.`)
};

/**
* | output |
* | --- |
* | "No conversations yet." |
*
* @param {Chat_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_empty = /** @type {((inputs?: Chat_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_empty(inputs)
	return cs_chat_empty(inputs)
});